import PropTypes from 'prop-types';
import { FormProvider as Form } from 'react-hook-form';

FormProvider.propTypes = {
  children: PropTypes.node.isRequired,
  methods: PropTypes.object.isRequired,
  onSubmit: PropTypes.func,
  style: PropTypes.object,
};

export default function FormProvider({ children, onSubmit, methods, style }) {
  return (
    <Form {...methods}>
      <form onSubmit={onSubmit} style={style}>{children}</form>
    </Form>
  );
}
